export default {
  intro: {
    header: 'Integrate PayPortal API in minutes',
    desc: 'Quickly leverage PayPortal, to create your first customer, charge, and reconcile banking and payment details with your applications or accounting systems.',
    cta: 'View API Docs',
  },
  business: {
    header: 'APIs Driven for Customization',
    desc: 'From account creation to payouts, our platform can be customized to meet your unique payment needs. Our users range from non-profits, SMBs to Fortune 500 companies.',
    options: [
      {
        id: 1,
        title: 'Secure',
        desc: 'Inbuilt fraud prevention, that can be extended using custom workflows for additional compliance such as GDPR.',
        img: 'home',
      },
      {
        id: 2,
        title: 'Scalable',
        desc: 'Create heavy duty workflows, issue mass payouts and let us our systems handle the dirty work.',
        img: 'credit_card',
      },
      {
        id: 3,
        title: 'Documented',
        desc: 'Get familiar with our workflows from e-commerce and recurring billing to integrated banking with <span class="font-weight-bold">ERP as a service</span> and everything in between using small code snippets.',
        img: 'book',
      },
      {
        id: 4,
        title: 'API & Sandbox',
        desc: 'Test out our APIs using our developer sandbox before each deployment to production.',
        img: 'book',
      },
    ],
  },
};
